import React from 'react';
import { Box, Text, Stack, HStack, Avatar, Button, IconButton } from '@chakra-ui/react';
import { FaCalendarAlt } from 'react-icons/fa';

const StudentActivity = () => {
  const activities = [
    {
      id: 1,
      title: '1st place in "Chess"',
      description: 'This event took place in Our School',
      image: 'https://example.com/image1.jpg', // Add relevant image URL
    },
    {
      id: 2,
      title: 'Participated in "Carrom"',
      description: 'Justin Lee participated in "Carrom"',
      image: 'https://example.com/image2.jpg',
    },
    {
      id: 3,
      title: '1st place in "100M"',
      description: 'This event took place in Our School',
      image: 'https://example.com/image3.jpg',
    },

  ];

  return (
    <Box p={5} maxW="sm" borderWidth="1px" borderRadius="lg" overflow="hidden">
      <HStack mb={4} justifyContent="space-between">
        <Text fontSize="lg" fontWeight="bold">Student Activity</Text>
        <HStack>
          <IconButton
            aria-label="Calendar"
            icon={<FaCalendarAlt />}
            size="sm"
            variant="ghost"
          />
          <Button size="sm" variant="link">
            This Month
          </Button>
        </HStack>
      </HStack>

      <Stack spacing={4}>
        {activities.map((activity) => (
          <HStack key={activity.id} p={4} borderWidth="1px" borderRadius="md">
            <Avatar src={activity.image} size="lg" />
            <Box>
              <Text fontWeight="bold">{activity.title}</Text>
              <Text fontSize="sm" color="gray.500">
                {activity.description}
              </Text>
            </Box>
          </HStack>
        ))}
      </Stack>
    </Box>
  );
};

export default StudentActivity;
